import { useEffect } from 'react';
import { readCookieConsent } from '@/lib/cookieConsent';
import { COOKIE_CONSENT_UPDATED_EVENT } from '@/lib/sentryInit';
import { loadApolloIfAnalyticsAllowed } from '@/lib/apolloInit';

/** Loads the Apollo website tracker only when Analytics cookies are enabled. */
export function ApolloConsentBridge() {
  useEffect(() => {
    const stored = readCookieConsent();
    loadApolloIfAnalyticsAllowed(Boolean(stored?.analytics));

    const onUpdate = (event: Event) => {
      const detail = (event as CustomEvent<{ analytics?: boolean }>).detail;
      const analytics = detail?.analytics ?? readCookieConsent()?.analytics ?? false;
      loadApolloIfAnalyticsAllowed(Boolean(analytics));
    };

    window.addEventListener(COOKIE_CONSENT_UPDATED_EVENT, onUpdate);
    return () => window.removeEventListener(COOKIE_CONSENT_UPDATED_EVENT, onUpdate);
  }, []);

  return null;
}
